"use strict";
/**
 * Documentation Enums — document management system.
 *
 * Enums for the Documentation module (type, format, status).
 * All enums follow the new standard: snake_case values + LABELS objects.
 *
 * @see .claude/rules/enums.md for conventions
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCUMENTATION_STATUS_LABELS = exports.DocumentationStatus = exports.DOCUMENTATION_FORMAT_LABELS = exports.DocumentationFormat = exports.DOCUMENTATION_TYPE_LABELS = exports.DocumentationType = void 0;
// ─── Documentation Type ─────────────────────────────────────────────────────
/**
 * Classifies the category of the document.
 */
var DocumentationType;
(function (DocumentationType) {
    DocumentationType["guides"] = "guides";
    DocumentationType["admon"] = "admon";
    DocumentationType["guidances"] = "guidances";
    DocumentationType["formats"] = "formats";
    DocumentationType["support"] = "support";
    DocumentationType["controls"] = "controls";
    DocumentationType["veterinary"] = "veterinary";
})(DocumentationType || (exports.DocumentationType = DocumentationType = {}));
exports.DOCUMENTATION_TYPE_LABELS = {
    [DocumentationType.guides]: "Guías y protocolos",
    [DocumentationType.admon]: "Administración",
    [DocumentationType.guidances]: "Lineamientos",
    [DocumentationType.formats]: "Formatos",
    [DocumentationType.support]: "Apoyo",
    [DocumentationType.controls]: "Controles",
    [DocumentationType.veterinary]: "Veterinario",
};
// ─── Documentation Format ───────────────────────────────────────────────────
/**
 * File format of the document.
 */
var DocumentationFormat;
(function (DocumentationFormat) {
    DocumentationFormat["video"] = "video";
    DocumentationFormat["spreadsheet"] = "spreadsheet";
    DocumentationFormat["pdf"] = "pdf";
    DocumentationFormat["text_document"] = "text_document";
    DocumentationFormat["other"] = "other";
})(DocumentationFormat || (exports.DocumentationFormat = DocumentationFormat = {}));
exports.DOCUMENTATION_FORMAT_LABELS = {
    [DocumentationFormat.video]: "Video",
    [DocumentationFormat.spreadsheet]: "Hoja de cálculo",
    [DocumentationFormat.pdf]: "PDF",
    [DocumentationFormat.text_document]: "Documento de texto",
    [DocumentationFormat.other]: "Otro",
};
// ─── Documentation Status ───────────────────────────────────────────────────
/**
 * Currency status of the document content.
 */
var DocumentationStatus;
(function (DocumentationStatus) {
    DocumentationStatus["updated"] = "updated";
    DocumentationStatus["semi_outdated"] = "semi_outdated";
    DocumentationStatus["outdated"] = "outdated";
    DocumentationStatus["not_valid"] = "not_valid";
    DocumentationStatus["not_applicable"] = "not_applicable";
})(DocumentationStatus || (exports.DocumentationStatus = DocumentationStatus = {}));
exports.DOCUMENTATION_STATUS_LABELS = {
    [DocumentationStatus.updated]: "Actualizado",
    [DocumentationStatus.semi_outdated]: "Semidesactualizado",
    [DocumentationStatus.outdated]: "Desactualizado",
    [DocumentationStatus.not_valid]: "No vigente",
    [DocumentationStatus.not_applicable]: "No aplica",
};
